import React, { useState, useEffect, useContext } from "react";
import { Building } from "generated/graphql";
import { AuthContext } from "Firebase/AuthProvider";
import { OnlineBuildingGuard } from "lib/realtimeDBTypes";
import firebase from "../Firebase/firebase";
import update from "immutability-helper";
import AgoraRTC, {
  IAgoraRTCClient,
  IMicrophoneAudioTrack,
} from "agora-rtc-sdk-ng";
import axios from "axios";


const DEFAULT_STATE: Pick<
  Building,
  "BuildingName" | "Id" | "LastUpdateDateTime" | "centerLat" | "centerLong"
> = {
  BuildingName: "",
  Id: "",
  LastUpdateDateTime: "",
  centerLat: 0,
  centerLong: 0,
};

export enum CallStatusENUM {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  CHECKING = "CHECKING",
}

export interface BuildingState {
  onlineBuildingGuards: OnlineBuildingGuard[];
  call_status: CallStatusENUM | null;
  firebaseListeners: firebase.database.Reference[];
}

const DEFAULT_BUILDING_STATE: BuildingState = {
  onlineBuildingGuards: [],
  call_status: null,
  firebaseListeners: [],
};

export interface Incident {
  title: string
  description: string
  endDateTime: string
  id: string
  imageUrl: string
  lat: number
  lng: number
  shiftguardId: string
  startDateTime: string
}
interface IncidentsState {
  incidents: Incident[]
}

const DEFAULT_INCIDENTS_STATE: IncidentsState = {
  incidents: []
}

interface ChatMessage {
  content: string
  userName: string
  timestamp: number
  uid: number
}

interface ChatMessageState {
  chats: ChatMessage[]
}

const DEFAULT_CHATS_STATE: ChatMessageState = {
  chats: []
}

interface BuildingContextType {
  currentBuilding: Pick<
    Building,
    "BuildingName" | "Id" | "LastUpdateDateTime" | "centerLat" | "centerLong"
  >;
  updateBuilding(
    building: Pick<
      Building,
      "BuildingName" | "Id" | "LastUpdateDateTime" | "centerLat" | "centerLong"
    >
  ): void;
  buildingState: BuildingState;
  incidentState: IncidentsState;
  chatState:ChatMessageState;
}

export const BuildingContext = React.createContext<Partial<BuildingContextType>>(
  {}
);

export const BuildingProvider = ({ children }: any) => {
  const localState = localStorage.getItem("currentBuilding");
  const { getDatabase, user } = useContext(AuthContext);
  const [currentBuilding, setBuilding] = useState(
    !!localState ? JSON.parse(localState) : DEFAULT_STATE
  );
  const [buildingState, setBuildingState] = useState(DEFAULT_BUILDING_STATE);
  const [incidentState, setIncidents] = useState(DEFAULT_INCIDENTS_STATE);
  const [chatState, setChatState] = useState(DEFAULT_CHATS_STATE)
  const removeAndAddFirebaseListners = () => {
    for (let i = 0; i < buildingState.firebaseListeners.length; i++) {
      const listenerObject = buildingState.firebaseListeners[i];
      listenerObject.off();
    }
    initFirebase();
  };

  const initFirebase = () => {
    if (!!getDatabase) {
      const database = getDatabase();
      const onlineBuildingGuardListener = database.ref(
        "buildings/" + currentBuilding!.Id + "/onlineBuildingGuards"
      );
      onlineBuildingGuardListener.on("value", (snapshot) => {
        const onlineBuildingGuards = snapshot.val();
        console.log("🚀 ~ file: BuildingProvider.tsx ~ line 83 ~ onlineBuildingGuardListener.on ~ onlineBuildingGuards", onlineBuildingGuards)
        setBuildingState({ ...buildingState, onlineBuildingGuards });
      });
      const incidentListener = database.ref(
        "buildings/" + currentBuilding!.Id + "/incidents"
      );

      incidentListener.on("value",(snapshot)=>{
        const incidents = snapshot.val();
        console.log("🚀 ~ file: BuildingProvider.tsx ~ line 131 ~ incidentListener.on ~ incidents", incidents)
        setIncidents({ ...incidentState, incidents})
      })

      const chatsListener = database
        .ref("buildings/" + currentBuilding.Id + "/chats")
        .orderByChild("timestamp");

      chatsListener.on("value", (snapshot) => {
        const chats: ChatMessage[] = [];
        snapshot.forEach((snap) => {
          chats.push(snap.val());
        });
        chats.sort(function (a, b) {
          return a.timestamp - b.timestamp;
        });

        setChatState({...chatState, chats})
      });
      const callStatusListener = database.ref(
        "buildings/" + currentBuilding!.Id + "/call_status"
      );

      // callStatusListener.on("value", (snapshot) => {
      //   const call_status = snapshot.val() as CallStatusENUM;
      //   setBuildingState({ ...buildingState, call_status });
      // });
      // setBuildingState(
      //   update(buildingState, {
      //     firebaseListeners: {
      //       $push: [
      //         onlineBuildingGuardListener,
      //         callStatusListener,
      //         incidentListener,
      //       ],
      //     },
      //   })
      // );
    }
  };
  const updateBuilding = (
    building: Pick<
      Building,
      "BuildingName" | "Id" | "LastUpdateDateTime" | "centerLat" | "centerLong"
    >
  ) => {
    setBuilding(building);
  };
  useEffect(() => {
    localStorage.setItem("currentBuilding", JSON.stringify(currentBuilding));
    //removeFirebaseListners();
    removeAndAddFirebaseListners()
  }, [currentBuilding]);

  useEffect(()=>{
    console.log("🚀 ~ file: BuildingProvider.tsx ~ line 127 ~ BuildingProvider ~ buildingState", buildingState)
    //localStorage.setItem("buildingState", JSON.stringify(buildingState));
  }, [buildingState])

  
  return (
    <BuildingContext.Provider
      value={{
        currentBuilding,
        updateBuilding,
        buildingState,
        incidentState,
        chatState
      }}
    >
      {children}
    </BuildingContext.Provider>
  );
};
